import { render, staticRenderFns } from "./HeaderPostMatch.vue?vue&type=template&id=4bad5f2a&scoped=true&"
import script from "./HeaderPostMatch.vue?vue&type=script&lang=js&"
export * from "./HeaderPostMatch.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPostMatch.vue?vue&type=style&index=0&id=4bad5f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bad5f2a",
  null
  
)

export default component.exports